(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["capsule-product-fit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('capsule-purchase-link')) {
  customElements.define('capsule-purchase-link', class extends HTMLElement {
    connectedCallback() {
      this.mainButton = document.getElementById('ProductSubmitButton-' + this.dataset.sectionId);
      if (!this.mainButton) return;
      this.action = this.querySelector('button');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.inView = true;
      this.visible = (element) => Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
      this.schedule = () => {
        if (this.frame != null) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.update();
        });
      };
      this.update = () => {
        if (!this.mobile.matches) {
          if (!this.hidden) this.hidden = true;
          if (document.body.classList.contains('cf-has-purchase-link')) document.body.classList.remove('cf-has-purchase-link');
          return;
        }
        const blocked = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, cart-drawer.active, .menu-drawer-container[open], dialog[open], details[open] .search-modal')].some(this.visible);
        const shouldHide = !this.mobile.matches || this.inView || blocked;
        if (this.hidden !== shouldHide) this.hidden = shouldHide;
        if (document.body.classList.contains('cf-has-purchase-link') === shouldHide) document.body.classList.toggle('cf-has-purchase-link', !shouldHide);
        this.action.disabled = !this.mainButton.isConnected;
        const price = document.getElementById('price-' + this.dataset.sectionId);
        const current = price?.querySelector('.price__sale .price-item--sale') && price.querySelector('.price--on-sale')
          ? price.querySelector('.price__sale .price-item--sale')
          : price?.querySelector('.price__regular .price-item--regular');
        if (current && this.querySelector('[data-price]').textContent !== current.textContent.trim()) this.querySelector('[data-price]').textContent = current.textContent.trim();
      };
      this.goToPurchase = () => {
        if (!this.mainButton.isConnected) return;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.mainButton.scrollIntoView({block:'center',behavior});
        if (!this.mainButton.disabled) this.mainButton.focus({preventScroll:true});
      };
      this.action.addEventListener('click', this.goToPurchase);
      this.mobile.addEventListener('change', this.schedule);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.schedule();
      }, {threshold:0.2});
      this.observer.observe(this.mainButton);
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(document.body, {attributes:true,childList:true,subtree:true,attributeFilter:['class','open','hidden','style']});
      const price = document.getElementById('price-' + this.dataset.sectionId);
      this.prices = new MutationObserver(this.schedule);
      if (price) this.prices.observe(price, {childList:true,characterData:true,subtree:true});
      this.schedule();
    }
    disconnectedCallback() {
      if (this.frame != null) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.observer?.disconnect();
      this.mutations?.disconnect();
      this.prices?.disconnect();
      this.action?.removeEventListener('click', this.goToPurchase);
      this.mobile?.removeEventListener('change', this.schedule);
      document.body.classList.remove('cf-has-purchase-link');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
